import { FC, useContext } from 'react'
import './ControlsPlayback.scss'
import { ControlsButton } from './ControlsButton'
import { InternalContext } from '../contexts/InternalContext'
import SvgStop from '../../components/icons/Stop'
import SvgPlay from '../../components/icons/Play'
import SvgPause from '../../components/icons/Pause'
import { ControlsVolume } from './ControlsVolume'
import { useHotkey } from '../../hooks/useHotkey'
import { AppContext } from '../../AppContext'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'

export const ControlsPlayback: FC = () => {
  const { hotkeysEnabled } = useContext(AppContext)
  const {
    playbackCursorPosition,
    setPlaybackCursorPosition,
    audioPlayer: { playback, stop, play, getPlaybackPosition },
  } = useContext(InternalContext)

  const onPlayClick = () => {
    logger.log(LogActionType.PlaybackPlayButtonClick)

    play(playbackCursorPosition || 0)
  }

  const onPauseClick = () => {
    logger.log(LogActionType.PlaybackPauseButtonClick)

    setPlaybackCursorPosition(getPlaybackPosition())
    stop()
  }

  const onStopClick = () => {
    logger.log(LogActionType.PlaybackStopButtonClick)

    setPlaybackCursorPosition(null)
    stop()
  }

  useHotkey(
    (event) => event.key === ' ',
    () => {
      if (playback) {
        logger.log(LogActionType.PlaybackPauseHotkeyPress)

        onPauseClick()
      } else {
        logger.log(LogActionType.PlaybackPlayHotkeyPress)

        onPlayClick()
      }
    },
    hotkeysEnabled,
  )

  return (
    <div className="ControlsPlayback">
      {playback ? (
        <ControlsButton onClick={onPauseClick} primary={true} title="Pause" caption="Space">
          <SvgPause />
        </ControlsButton>
      ) : (
        <ControlsButton onClick={onPlayClick} primary={true} title="Start" caption="Space">
          <SvgPlay />
        </ControlsButton>
      )}

      <ControlsButton onClick={onStopClick} disabled={!playbackCursorPosition && !playback} title="Stop">
        <SvgStop />
      </ControlsButton>

      <ControlsVolume />
    </div>
  )
}
